// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"styles_inputFile__2r6Yv","inputLabel":"styles_inputLabel__2kRio"};